import { z } from "zod";

export const dataReportStatsSchema = z.object({
  impressions: z.number().nullable().optional(),
  impressions_prev: z.number().nullable().optional(),
  impressions_delta: z.number().nullable().optional(),
  impressions_percent: z.number().nullable().optional(),

  clicks: z.number().nullable().optional(),
  clicks_prev: z.number().nullable().optional(),
  clicks_delta: z.number().nullable().optional(),
  clicks_percent: z.number().nullable().optional(),

  conversion: z.number().nullable().optional(),
  conversion_prev: z.number().nullable().optional(),
  conversion_delta: z.number().nullable().optional(),
  conversion_percent: z.number().nullable().optional(),

  cost: z.number().nullable().optional(),
  cost_prev: z.number().nullable().optional(),
  cost_delta: z.number().nullable().optional(),
  cost_percent: z.number().nullable().optional(),

  attributed_conversions_7d: z.number().nullable().optional(),
  attributed_conversions_7d_prev: z.number().nullable().optional(),
  attributed_conversions_7d_delta: z.number().nullable().optional(),
  attributed_conversions_7d_percent: z.number().nullable().optional(),

  attributed_units_ordered_7d: z.number().nullable().optional(),
  attributed_units_ordered_7d_prev: z.number().nullable().optional(),
  attributed_units_ordered_7d_delta: z.number().nullable().optional(),
  attributed_units_ordered_7d_percent: z.number().nullable().optional(),

  attributed_sales_7d: z.number().nullable().optional(),
  attributed_sales_7d_prev: z.number().nullable().optional(),
  attributed_sales_7d_delta: z.number().nullable().optional(),
  attributed_sales_7d_percent: z.number().nullable().optional(),

  attributed_conversions_7d_same_sku: z.number().nullable().optional(),
  attributed_conversions_7d_same_sku_prev: z.number().nullable().optional(),
  attributed_conversions_7d_same_sku_delta: z.number().nullable().optional(),
  attributed_conversions_7d_same_sku_percent: z.number().nullable().optional(),

  attributed_units_ordered_7d_same_sku: z.number().nullable().optional(),
  attributed_units_ordered_7d_same_sku_prev: z.number().nullable().optional(),
  attributed_units_ordered_7d_same_sku_delta: z.number().nullable().optional(),
  attributed_units_ordered_7d_same_sku_percent: z.number().nullable().optional(),

  attributed_sales_7d_same_sku: z.number().nullable().optional(),
  attributed_sales_7d_same_sku_prev: z.number().nullable().optional(),
  attributed_sales_7d_same_sku_delta: z.number().nullable().optional(),
  attributed_sales_7d_same_sku_percent: z.number().nullable().optional(),

  total_sales: z.number().nullable().optional(),
  total_sales_prev: z.number().nullable().optional(),
  total_sales_delta: z.number().nullable().optional(),
  total_sales_percent: z.number().nullable().optional(),

  ad_sales: z.number().nullable().optional(),
  ad_sales_prev: z.number().nullable().optional(),
  ad_sales_delta: z.number().nullable().optional(),
  ad_sales_percent: z.number().nullable().optional(),

  ad_sales_same_sku: z.number().nullable().optional(),
  ad_sales_same_sku_prev: z.number().nullable().optional(),
  ad_sales_same_sku_delta: z.number().nullable().optional(),
  ad_sales_same_sku_percent: z.number().nullable().optional(),

  total_units: z.number().nullable().optional(),
  total_units_prev: z.number().nullable().optional(),
  total_units_delta: z.number().nullable().optional(),
  total_units_percent: z.number().nullable().optional(),

  cost_per_click: z.number().nullable().optional(),
  cost_per_click_prev: z.number().nullable().optional(),
  cost_per_click_delta: z.number().nullable().optional(),
  cost_per_click_percent: z.number().nullable().optional(),

  click_thru_rate: z.number().nullable().optional(),
  click_thru_rate_prev: z.number().nullable().optional(),
  click_thru_rate_delta: z.number().nullable().optional(),
  click_thru_rate_percent: z.number().nullable().optional(),

  conv_rate: z.number().nullable().optional(),
  conv_rate_prev: z.number().nullable().optional(),
  conv_rate_delta: z.number().nullable().optional(),
  conv_rate_percent: z.number().nullable().optional(),

  acos: z.number().nullable().optional(),
  acos_prev: z.number().nullable().optional(),
  acos_delta: z.number().nullable().optional(),
  acos_percent: z.number().nullable().optional(),

  roas: z.number().nullable().optional(),
  roas_prev: z.number().nullable().optional(),
  roas_delta: z.number().nullable().optional(),
  roas_percent: z.number().nullable().optional(),

  total_roas: z.number().nullable().optional(),
  total_roas_prev: z.number().nullable().optional(),
  total_roas_delta: z.number().nullable().optional(),
  total_roas_percent: z.number().nullable().optional(),

  acos_same_sku: z.number().nullable().optional(),
  acos_same_sku_prev: z.number().nullable().optional(),
  acos_same_sku_delta: z.number().nullable().optional(),
  acos_same_sku_percent: z.number().nullable().optional(),

  total_acos: z.number().nullable().optional(),
  total_acos_prev: z.number().nullable().optional(),
  total_acos_delta: z.number().nullable().optional(),
  total_acos_percent: z.number().nullable().optional(),

  roas_same_sku: z.number().nullable().optional(),
  roas_same_sku_prev: z.number().nullable().optional(),
  roas_same_sku_delta: z.number().nullable().optional(),
  roas_same_sku_percent: z.number().nullable().optional(),

  total_cost: z.number().nullable().optional(),
  total_cost_prev: z.number().nullable().optional(),
  total_cost_delta: z.number().nullable().optional(),
  total_cost_percent: z.number().nullable().optional(),
});

export const statsSchema = z.object({
  impressions: z.number().nullable(),
  impressions_prev: z.number().nullable(),
  impressions_delta: z.number().nullable(),
  impressions_percent: z.number().nullable(),

  clicks: z.number().nullable(),
  clicks_prev: z.number().nullable(),
  clicks_delta: z.number().nullable(),
  clicks_percent: z.number().nullable(),

  conversion: z.number().nullable(),
  conversion_prev: z.number().nullable(),
  conversion_delta: z.number().nullable(),
  conversion_percent: z.number().nullable(),

  cost: z.number().nullable(),
  cost_prev: z.number().nullable(),
  cost_delta: z.number().nullable(),
  cost_percent: z.number().nullable(),

  attributed_conversions_7d: z.number().nullable(),
  attributed_conversions_7d_prev: z.number().nullable(),
  attributed_conversions_7d_delta: z.number().nullable(),
  attributed_conversions_7d_percent: z.number().nullable(),

  attributed_units_ordered_7d: z.number().nullable(),
  attributed_units_ordered_7d_prev: z.number().nullable(),
  attributed_units_ordered_7d_delta: z.number().nullable(),
  attributed_units_ordered_7d_percent: z.number().nullable(),

  attributed_sales_7d: z.number().nullable(),
  attributed_sales_7d_prev: z.number().nullable(),
  attributed_sales_7d_delta: z.number().nullable(),
  attributed_sales_7d_percent: z.number().nullable(),

  attributed_conversions_7d_same_sku: z.number().nullable(),
  attributed_conversions_7d_same_sku_prev: z.number().nullable(),
  attributed_conversions_7d_same_sku_delta: z.number().nullable(),
  attributed_conversions_7d_same_sku_percent: z.number().nullable(),

  attributed_units_ordered_7d_same_sku: z.number().nullable(),
  attributed_units_ordered_7d_same_sku_prev: z.number().nullable(),
  attributed_units_ordered_7d_same_sku_delta: z.number().nullable(),
  attributed_units_ordered_7d_same_sku_percent: z.number().nullable(),

  attributed_sales_7d_same_sku: z.number().nullable(),
  attributed_sales_7d_same_sku_prev: z.number().nullable(),
  attributed_sales_7d_same_sku_delta: z.number().nullable(),
  attributed_sales_7d_same_sku_percent: z.number().nullable(),

  total_sales: z.number().nullable(),
  total_sales_prev: z.number().nullable(),
  total_sales_delta: z.number().nullable(),
  total_sales_percent: z.number().nullable(),

  ad_sales: z.number().nullable(),
  ad_sales_prev: z.number().nullable(),
  ad_sales_delta: z.number().nullable(),
  ad_sales_percent: z.number().nullable(),

  ad_sales_same_sku: z.number().nullable(),
  ad_sales_same_sku_prev: z.number().nullable(),
  ad_sales_same_sku_delta: z.number().nullable(),
  ad_sales_same_sku_percent: z.number().nullable(),

  total_units: z.number().nullable(),
  total_units_prev: z.number().nullable(),
  total_units_delta: z.number().nullable(),
  total_units_percent: z.number().nullable(),

  cost_per_click: z.number().nullable(),
  cost_per_click_prev: z.number().nullable(),
  cost_per_click_delta: z.number().nullable(),
  cost_per_click_percent: z.number().nullable(),

  click_thru_rate: z.number().nullable(),
  click_thru_rate_prev: z.number().nullable(),
  click_thru_rate_delta: z.number().nullable(),
  click_thru_rate_percent: z.number().nullable(),

  conv_rate: z.number().nullable(),
  conv_rate_prev: z.number().nullable(),
  conv_rate_delta: z.number().nullable(),
  conv_rate_percent: z.number().nullable(),

  acos: z.number().nullable(),
  acos_prev: z.number().nullable(),
  acos_delta: z.number().nullable(),
  acos_percent: z.number().nullable(),

  roas: z.number().nullable(),
  roas_prev: z.number().nullable(),
  roas_delta: z.number().nullable(),
  roas_percent: z.number().nullable(),

  total_roas: z.number().nullable(),
  total_roas_prev: z.number().nullable(),
  total_roas_delta: z.number().nullable(),
  total_roas_percent: z.number().nullable(),

  acos_same_sku: z.number().nullable(),
  acos_same_sku_prev: z.number().nullable(),
  acos_same_sku_delta: z.number().nullable(),
  acos_same_sku_percent: z.number().nullable(),

  total_acos: z.number().nullable(),
  total_acos_prev: z.number().nullable(),
  total_acos_delta: z.number().nullable(),
  total_acos_percent: z.number().nullable(),

  roas_same_sku: z.number().nullable(),
  roas_same_sku_prev: z.number().nullable(),
  roas_same_sku_delta: z.number().nullable(),
  roas_same_sku_percent: z.number().nullable(),

  total_cost: z.number().nullable().optional(),
  total_cost_prev: z.number().nullable().optional(),
  total_cost_delta: z.number().nullable().optional(),
  total_cost_percent: z.number().nullable().optional(),
});

export const productAdStatsSchema = z.object({
  impressions: z.number().nullable(),
  impressions_prev: z.number().nullable(),
  impressions_delta: z.number().nullable(),
  impressions_percent: z.number().nullable(),

  clicks: z.number().nullable(),
  clicks_prev: z.number().nullable(),
  clicks_delta: z.number().nullable(),
  clicks_percent: z.number().nullable(),

  conversion: z.number().nullable(),
  conversion_prev: z.number().nullable(),
  conversion_delta: z.number().nullable(),
  conversion_percent: z.number().nullable(),

  conversion_same_sku: z.number().nullable(),
  conversion_same_sku_prev: z.number().nullable(),
  conversion_same_sku_delta: z.number().nullable(),
  conversion_same_sku_percent: z.number().nullable(),

  cost: z.number().nullable(),
  cost_prev: z.number().nullable(),
  cost_delta: z.number().nullable(),
  cost_percent: z.number().nullable(),

  attributed_conversions_7d: z.number().nullable(),
  attributed_conversions_7d_prev: z.number().nullable(),
  attributed_conversions_7d_delta: z.number().nullable(),
  attributed_conversions_7d_percent: z.number().nullable(),

  attributed_units_ordered_7d: z.number().nullable(),
  attributed_units_ordered_7d_prev: z.number().nullable(),
  attributed_units_ordered_7d_delta: z.number().nullable(),
  attributed_units_ordered_7d_percent: z.number().nullable(),

  attributed_sales_7d: z.number().nullable(),
  attributed_sales_7d_prev: z.number().nullable(),
  attributed_sales_7d_delta: z.number().nullable(),
  attributed_sales_7d_percent: z.number().nullable(),

  attributed_conversions_7d_same_sku: z.number().nullable(),
  attributed_conversions_7d_same_sku_prev: z.number().nullable(),
  attributed_conversions_7d_same_sku_delta: z.number().nullable(),
  attributed_conversions_7d_same_sku_percent: z.number().nullable(),

  attributed_units_ordered_7d_same_sku: z.number().nullable(),
  attributed_units_ordered_7d_same_sku_prev: z.number().nullable(),
  attributed_units_ordered_7d_same_sku_delta: z.number().nullable(),
  attributed_units_ordered_7d_same_sku_percent: z.number().nullable(),

  attributed_sales_7d_same_sku: z.number().nullable(),
  attributed_sales_7d_same_sku_prev: z.number().nullable(),
  attributed_sales_7d_same_sku_delta: z.number().nullable(),
  attributed_sales_7d_same_sku_percent: z.number().nullable(),

  ad_sales: z.number().nullable(),
  ad_sales_prev: z.number().nullable(),
  ad_sales_delta: z.number().nullable(),
  ad_sales_percent: z.number().nullable(),

  ad_sales_same_sku: z.number().nullable(),
  ad_sales_same_sku_prev: z.number().nullable(),
  ad_sales_same_sku_delta: z.number().nullable(),
  ad_sales_same_sku_percent: z.number().nullable(),

  total_units: z.number().nullable(),
  total_units_prev: z.number().nullable(),
  total_units_delta: z.number().nullable(),
  total_units_percent: z.number().nullable(),

  cost_per_click: z.number().nullable(),
  cost_per_click_prev: z.number().nullable(),
  cost_per_click_delta: z.number().nullable(),
  cost_per_click_percent: z.number().nullable(),

  click_thru_rate: z.number().nullable(),
  click_thru_rate_prev: z.number().nullable(),
  click_thru_rate_delta: z.number().nullable(),
  click_thru_rate_percent: z.number().nullable(),

  conv_rate: z.number().nullable(),
  conv_rate_prev: z.number().nullable(),
  conv_rate_delta: z.number().nullable(),
  conv_rate_percent: z.number().nullable(),

  acos: z.number().nullable(),
  acos_prev: z.number().nullable(),
  acos_delta: z.number().nullable(),
  acos_percent: z.number().nullable(),

  roas: z.number().nullable(),
  roas_prev: z.number().nullable(),
  roas_delta: z.number().nullable(),
  roas_percent: z.number().nullable(),

  acos_same_sku: z.number().nullable(),
  acos_same_sku_prev: z.number().nullable(),
  acos_same_sku_delta: z.number().nullable(),
  acos_same_sku_percent: z.number().nullable(),

  roas_same_sku: z.number().nullable(),
  roas_same_sku_prev: z.number().nullable(),
  roas_same_sku_delta: z.number().nullable(),
  roas_same_sku_percent: z.number().nullable(),

  total_cost: z.number().nullable().optional(),
  total_cost_prev: z.number().nullable().optional(),
  total_cost_delta: z.number().nullable().optional(),
  total_cost_percent: z.number().nullable().optional(),
});
